import React from 'react';

import FormControl from './FormControl';

const propTypes = {};

class ZipInput extends React.Component {
  handleChange = e => {
    const { value } = e.target;

    if (!value.match(/^\d{0,5}$/)) return;
    this.props.onChange(value);
  };

  render() {
    return (
      <FormControl
        {...this.props}
        type="text"
        pattern="[0-9]*" // this triggers the right keyboard on mobile
        onChange={this.handleChange}
      />
    );
  }
}

ZipInput.propTypes = propTypes;

export default ZipInput;
